import { randomNumber } from '../../../utilities'
import { STEP_IDS } from '../constants'
import { FillablePDFsConstants } from './fillablePDFs.constants'
import { IFillablePDF, IFillablePDFsAction, IFillablePDFsState } from './fillablePDFs.types'

export const initialFillablePDF = (): IFillablePDF => {
  return {
    id: randomNumber().toString(),
    name: '',
    author: null,
    customInputs: [],
    showModal: false,
    pdfDocId: '',
    pdfUrl: '',
    pdfLoading: true,
    pdfError: '',
  }
}

export const initialFillablePDFsState: IFillablePDFsState = {
  ...initialFillablePDF(),
  __currentStep: STEP_IDS.DETAILS,
  __deleteFillablePDFId: '',
  fillablePDFsList: [],
}

export function fillablePDFsReducer(
  state: IFillablePDFsState = initialFillablePDFsState,
  action: IFillablePDFsAction
): IFillablePDFsState {
  switch (action.type) {
    case FillablePDFsConstants.SET_CURRENT_STEP:
      return { ...state, __currentStep: action.__currentStep || 1 }
    case FillablePDFsConstants.SET_AUTHOR:
      return { ...state, author: action.author }
    case FillablePDFsConstants.SET_CUSTOM_INPUTS:
      return { ...state, customInputs: action.customInputs }
    case FillablePDFsConstants.SET_FILLABLE_PDF:
      return { ...action.fillablePDFsState, __currentStep: action.fillablePDFsState.__currentStep || 1 }
    case FillablePDFsConstants.RESET_FILLABLE_PDFS:
      return {
        ...initialFillablePDF(),
        __currentStep: STEP_IDS.DETAILS,
        __deleteFillablePDFId: '',
        fillablePDFsList: state.fillablePDFsList,
      }
    case FillablePDFsConstants.RESET_FILLABLE_PDFS_ON_CHART_EXIT:
      return initialFillablePDFsState
    case FillablePDFsConstants.DELETE_FILLABLE_PDF:
      return { ...state, __deleteFillablePDFId: action.id }
    case FillablePDFsConstants.SET_FILLABLE_PDFS_LIST:
      return { ...state, fillablePDFsList: action.fillablePDFsList }
    case FillablePDFsConstants.SET_SHOW_MODAL:
      return { ...state, showModal: action.showModal }
    case FillablePDFsConstants.SET_PDF_ID:
      return { ...state, id: action.id }
    case FillablePDFsConstants.SET_PDF_NAME:
      return { ...state, name: action.name }
    case FillablePDFsConstants.SET_PDF_LOADING:
      return { ...state, pdfLoading: action.pdfLoading }
    case FillablePDFsConstants.SET_PDF_URL:
      return { ...state, pdfUrl: action.pdfUrl, pdfError: '' }
    case FillablePDFsConstants.SET_PDF_ERROR:
      return { ...state, pdfError: action.pdfError, pdfLoading: false }
    default:
      return state
  }
}
